<template>
  <div class="login-logs general-container">
    <!--表格数据-->
    <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
      <el-tab-pane label="日志记录" name="0">
        <el-form ref="logQueryForm" class="pagination-table-query-form" :inline="true"
                 @keyup.enter.native="handleLogFormQuery()">
          <el-form-item label="生成时间">
            <uni-date-range-picker
              v-model="logDates"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </uni-date-range-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleLogFormQuery()" type="primary">查 询</el-button>
            <el-button @click="resetLogQueryForm()">重 置</el-button>
          </el-form-item>
        </el-form>
        <div class="pagination-table-container">
          <el-table :data="logTableData"
                    ref="logTable"
                    v-loading="loading"
                    border highlight-current-row
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    element-loading-spinner="el-icon-loading"
                    element-loading-text="努力加载中..."
                    style="width: 100%"
                    @selection-change="handleLogTableSelectionChange">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="操作类型" prop="logType" width="100">
              <template slot-scope="scope">{{getNameById(scope.row.logType, $type.logTypes)}}</template>
            </el-table-column>
            <el-table-column label="操作子类型" prop="logSubType" width="100">
              <template slot-scope="scope">{{getNameById(scope.row.logSubType, $type.systemLogTypes)}}</template>
            </el-table-column>
            <el-table-column label="操作用户" prop="userName" width="100"></el-table-column>
            <el-table-column label="主机IP" prop="operationHostIp" width="130"></el-table-column>
            <el-table-column label="生成时间" prop="operationTime" width="160">
              <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.operationTime)}}</template>
            </el-table-column>
            <el-table-column label="日志内容" prop="logContent" :show-overflow-tooltip="true"></el-table-column>
<!--            <el-table-column label="操作" width="100">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button-->
<!--                  class="col-btn"-->
<!--                  type="text"-->
<!--                  icon="el-icon-view"-->
<!--                  @click="handleLogView(scope.row)"-->
<!--                >查看-->
<!--                </el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
          <el-pagination v-show="logTableTotalRow > logTableQueryParams.pageSize"
                         background
                         @current-change="handleLogCurrentPageChange"
                         @size-change="handleLogPageSizeChange"
                         :current-page.sync="logTableQueryParams.pageNum"
                         :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                         :page-size.sync="logTableQueryParams.pageSize"
                         prev-text="上一页"
                         next-text="下一页"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="logTableTotalRow">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import LoginLogs from './LoginLogs.js'

export default LoginLogs
</script>

<style lang="scss">
// @import "OperationLogs.scss";
</style>



// WEBPACK FOOTER //
// src/views/events/LoginLogs/LoginLogs.vue